<mat-label [ngStyle]="{ fontWeight: fontWeight }">
    {{ label | translate }} <span class="required">{{ required ? '*' : '' }}</span>
</mat-label>
